(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('changelogDeltaService', changelogDeltaService);

  function changelogDeltaService(
    _,
    $filter
  ) {
    'ngInject';

    const actionClassMapping = {
      'Update': {
        actionClass: 'changelog-entry__action--update',
        actionText: 'updated'
      },
      'Archive': {
        actionClass: 'changelog-entry__action--delete',
        actionText: 'deleted'
      },
      'Delete': {
        actionClass: 'changelog-entry__action--delete',
        actionText: 'deleted'
      },
      'Create': {
        actionClass: '',
        actionText: 'created'
      }
    };

    const actionStatementMapping = {
      'UserInvitation': {
        'Create': log => [{ text: log.userName + ' sent an invitation to ' }, _strong(log.objectName)],
        'Update': log => [_strong(log.objectName), { text: ' accepted the invitation' }]
      },
      'IVRTree': {
        'Create': log => [{ text: log.userName + ' added a new IVR Tree ' }, _strong(log.objectName)]
      }
    };


    const service = {
      getActionViewData: getActionViewData,
      getActionStatement: getActionStatement
    };
    return service;

    function getActionViewData(log) {
      return angular.copy(actionClassMapping[log.action]);
    }

    /** Returns the statement as parts, `{ text, isStrong }`, where every `text` is plain text. */
    function getActionStatement(log) {
      const buildStatement = actionStatementMapping[log.typeName] && actionStatementMapping[log.typeName][log.action];

      if (buildStatement) {
        return buildStatement(log);
      }
      return _getDefaultStatement(log);
    }

    function _getDefaultStatement(log) {
      const viewData = getActionViewData(log);
      return [
        { text: (log.userName || '') + ' ' + viewData.actionText + ' ' + $filter('camelCaseFormat')(log.typeName) + ' ' },
        _strong(log.objectName || log.objectId)
      ];
    }

    function _strong(text) {
      return { text: text, isStrong: true };
    }

  }
})();
